import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const LegalPaymentSummary = () => {
  const [params] = useSearchParams();

  const sessionId = params.get("sessionId");
  const caseId = params.get("cd_Case_ID")
  console.log("params check caseid " , caseId);
  

  const navigate = useNavigate();

  const [amount, setAmount] = useState(0);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  console.log("ParamssessionId", sessionId);

  // GST 18%
  const gst = (amount * 0.18).toFixed(2);
  const totalAmount = Math.round(amount + parseFloat(gst));
  console.log('====================================');
  console.log("total amount", totalAmount);
  console.log('====================================');

useEffect(() => {
  if (caseId) {
    localStorage.setItem("caseId", caseId);
    console.log("Saved caseId:", caseId);
  } else {
    console.warn("caseId missing in URL");
  }
}, [caseId]);

  useEffect(() => {
    const validateSession = async () => {
      if (!sessionId) {
        alert("Invalid payment session");
        navigate("/");
        return;
      }

      try {
        const res = await axios.post(
          "https://clevdoc-legal-887efca919bb.herokuapp.com/v1/payment/validate",
          { sessionId }
        );

        if (!res.data.valid) {
          alert("Session expired or invalid");
          navigate("/");
          return;
        }

        // Save sessionId in sessionStorage (tab-specific)
        sessionStorage.setItem("paymentSessionId", res.data.sessionId);
;

        // Save validated data
       setAmount(res.data.amount);

// If logged in as Individual
if (res.data.userModel) {
  setUserData({
    name: `${res.data.userModel.first_name || ""} ${res.data.userModel.last_name || ""}`.trim(),
    email: res.data.userModel.email,
    phone: String(res.data.userModel.personal?.phone_number || ""),
    userId: res.data.userId,
  });
}

// If logged in as Organization
else if (res.data.organizationModel) {
  setUserData({
    name: res.data.organizationModel.name,
    email: res.data.organizationModel.email,
    phone: String(res.data.organizationModel.personal?.phone_number || ""),
    organizationId: res.data.organizationId,
  });
}
      } catch (err) {
        console.error("Session validation failed", err);
        alert("Unable to validate payment session");
        navigate("/");
      } finally {
        setLoading(false);
      }
    };

    validateSession();
  }, [sessionId]);

  const handlePayment = async () => {
    setLoading(true);
    try {
      // 1️⃣ Initiate payment (no headers needed)
       console.log('====================================');
       console.log("total amount", totalAmount);
       console.log('====================================');
      const payResponse = await axios.post(
        "https://clevdoc-legal-887efca919bb.herokuapp.com/v1/payment/v2-pay",
        {
          amount: String(Math.round(totalAmount * 100)),
          sessionId: sessionId,
          name: userData.name,
          email: userData.email,
          phone_number: String(userData.phone),

          // 👇 dynamically pass ONLY ONE
          ...(userData.userId && {  user: userData.userId }),
          ...(userData.organizationId && {
            organization: userData.organizationId,
          }),
        }
      );

      const { merchantTransactionId, redirectUrl, token } = payResponse.data;
      sessionStorage.setItem("pp_token", token);

      if (!merchantTransactionId || !redirectUrl || !token) {
        alert("Payment initiation failed");
        setLoading(false);
        return;
      }

      // Open PhonePe gateway in the same window
    window.location.href = redirectUrl;
      // window.location.href = redirectUrl;

      // 3️⃣ Poll status every 5 seconds
      const interval = setInterval(async () => {
        try {
          const statusResponse = await axios.post(
            "https://clevdoc-legal-887efca919bb.herokuapp.com/v1/payment/v2-order-status",
            {
              userTransactionId: merchantTransactionId,
              cd_Case_ID:caseId
            },
            {
              headers: {
                Authorization: `O-Bearer ${token}`,
              },
            }
          );

          const status = statusResponse.data.state;

          if (status === "COMPLETED") {
            clearInterval(interval);

            // const invoiceUrl = statusResponse.data.invoiceUrl || "";

            window.location.href = `https://clevdoc.com/payment-bridge?transactionId=${merchantTransactionId}&cd_Case_ID=${caseId}`;
          } // 🔵 Case 2 — PENDING → do nothing (just wait)
          else if (status === "PENDING") {
            console.log("Payment still pending...");
           
            // DO NOTHING → STAY ON SAME PAGE
          }

          // 🔴 Case 3 — FAILED → show error message
          else if (status === "FAILED") {
            clearInterval(interval);
            alert("Payment failed. Please try again.");
            navigate(
              `/legal-payment?status=failed&msg=${encodeURIComponent(
                "Payment failed, please try again"
              )}`
            );
          }
        } catch (err) {
          console.error("Status check error:", err);
        }
      }, 5000);
    } catch (err) {
      console.error("Payment initiation error:", err);
      alert("Failed to start payment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen p-10 mt-16">
      <div className="container mx-auto">
        <h1 className="text-3xl font-semibold underline mb-8">Order Summary</h1>
        <div className="grid grid-cols-2 gap-10">
          {/* Left Section - Details */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold mb-4">
              Legal Platform Arbitration Fees
            </h2>
            <div className="flex justify-between text-lg mb-2">
              <span>Amount</span>
              <span>INR {amount.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-lg mb-2">
              <span>GST (18%)</span>
              <span>INR {gst}</span>
            </div>
            <div className="flex justify-between text-xl font-bold mt-4 border-t pt-2">
              <span>Total Payable</span>
              <span>INR {totalAmount}</span>
            </div>
          </div>

          {/* Right Section - Payment Button */}
          <div className="bg-white rounded-lg shadow-md p-6 flex flex-col justify-between">
            <div>
              <h2 className="text-xl font-semibold mb-6">Proceed to Payment</h2>
              <p className="text-gray-600 mb-6">
                Click the button below to pay and complete your booking. You
                will be redirected to PhonePe.
              </p>
            </div>
            <button
              onClick={handlePayment}
              className={`w-full mt-4 bg-blue-600 text-white py-3 rounded-md ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={loading}
            >
              {loading ? "Processing Payment..." : "Proceed to Pay"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalPaymentSummary;
